<div class="modal-signup modal-content border-all-10px-modal">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-0px">
        <div class="row">
          <div class="col-md-10 padding-left-0px">
            <label class="margin-bottom-0px color-Assign font-weight-bold">Edit Service</label>
          </div>
          <div class="col-md-2 float-right">
            <button type="button" class="close" data-dismiss="modal"
                    (click)="activeModal.dismiss('Cross click')"
                    aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-2 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">Name :</label>
              </div>
              <div class="col-md-10 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">{{ServiceName}}</label>
              </div>
            </div>
          </div>
          

        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-4 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">Base Price :</label>
              </div>
              <div class="col-md-8 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">{{BasePrice}}</label>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-4 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">Ser.Category :</label>
              </div>
              <div class="col-md-8 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">{{CategoryName}}</label>
              </div>
            </div>
          </div>
          <!--<div class="col-md-6">
            <div class="row">
              <div class="col-md-4 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">Department :</label>
              </div>
              <div class="col-md-8 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">{{DepartmentName}}</label>
              </div>
            </div>
          </div>-->


        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-4 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">Service Type :</label>
              </div>
              <div class="col-md-8 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">{{ServiceType}}</label>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-5 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">Rev. Category :</label>
              </div>
              <div class="col-md-7 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">{{RevenueCategory}}</label>
              </div>
            </div>
          </div>


        </div>

      </div>

      <div class="modal-body padding-top-0px padding-bottom-0px">
        <div class="">
          <form class="form" novalidate="" (ngSubmit)="EditService()" #f="ngForm">

            <div class="card">

              <div class="card-body margin-left-zero padding-left-0px padding-right-0px padding-bottom-0px">
                <div class="row">
                  <div class="col-md-12 padding-l-0px">
                    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form padding-lr-0px">

                      <div class="card-body card-body-general padding-top-0px">

                        <div class="row">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                            <div class="row">
                              <div class="col-md-3 text-align-right">
                                <label for="firstName" class="margin-bottom-0px margin-top-5px">Service Name </label>
                              </div>
                              <div class="col-md-8">
                                <textarea class="form-control3 size-2 width-inherit"
                                          rows="2" placeholder="Service Name"
                                          name="UpdatedServiceName"
                                          [(ngModel)]="UpdatedServiceName"
                                          maxlength="140" minlength="1"></textarea>
                              </div>

                            </div>

                          </div>
                        </div>
                        <div class="row">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                            <div class="row">
                              <div class="col-md-3 text-align-right">
                                <label for="diaplayName" class="margin-bottom-0px margin-top-5px">Branch </label>
                              </div>
                              <div class="col-md-6">
                                <CustomDataByRequestType RequestedType="FacilityList" ActorCode={{ActorCode2}}
                                                         (keyChange)="Branchdata($event)"
                                                         [(ngModel)]="UpdatedSelectedFacilityCode" name="UpdatedSelectedFacilityCode" SelectedValue="UpdatedSelectedFacilityCode"
                                                         required>
                                </CustomDataByRequestType>
                              </div>
                            </div>


                          </div>
                        </div>
                        <div class="row">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                            <div class="row">
                              <div class="col-md-3 text-align-right">
                                <label for="diaplayName" class="margin-bottom-0px margin-top-5px">Branch Price </label>
                              </div>
                              <div class="col-md-6">
                                <input type="text" class="form-control" placeholder="Base Price"
                                       id="UpdatedBranchBasePrice"
                                       [(ngModel)]="UpdatedBranchBasePrice"
                                       name="UpdatedBranchBasePrice" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                       maxlength="30" #Price="ngModel">
                              </div>
                            </div>


                          </div>
                        </div>
                        <!--<div class="row">
    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
      <div class="row">
        <div class="col-md-3 text-align-right">
          <label for="diaplayName" class="margin-bottom-0px margin-top-5px">Base Price </label>
        </div>
        <div class="col-md-6">
          <input type="text" class="form-control" placeholder="Base Price"
                 id="UpdatedBasePrice"
                 [(ngModel)]="UpdatedBasePrice"
                 name="UpdatedBasePrice" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                 maxlength="30" #Price="ngModel">
        </div>
      </div>


    </div>
  </div>-->
                        <div class="row">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                            <div class="row">
                              <div class="col-md-3 text-align-right padding-left-0px">
                                <label for="firstName" class="margin-bottom-0px margin-top-5px">Ser.Category</label>
                              </div>
                              <div class="col-md-6">
                                <CustomDataByRequestType RequestedType="Service Category list" class="form-group" FacilityCode={{FacilityCode}}
                                                         [(ngModel)]="UpdatedServiceCategory" (keyChange)="ServiceCategoryChange($event)"
                                                         name="UpdatedCategoryName" #ServiceCategorylist="ngModel">
                                </CustomDataByRequestType>
                              </div>

                            </div>

                          </div>
                        </div>
                        <div class="row">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                            <div class="row">
                              <div class="col-md-3 text-align-right padding-left-0px">
                                <label for="firstName" class="margin-bottom-0px margin-top-5px">Rev.Category</label>
                              </div>
                              <div class="col-md-6">
                                <CodeTypeValue CodeType="REVCT" id="UpdatedRevenueCategory"
                                               [(ngModel)]="UpdatedRevenueCategory"
                                               name="UpdatedRevenueCategory">
                                </CodeTypeValue>
                              </div>

                            </div>

                          </div>
                        </div>
                        <div class="row">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                            <div class="row">
                              <div class="col-md-3 text-align-right padding-left-0px">
                                <label for="firstName" class="margin-bottom-0px margin-top-5px">Service Type</label>
                              </div>
                              <div class="col-md-6">
                                <CodeTypeValue CodeType="GSVCT" id="UpdatedServiceType"
                                               [(ngModel)]="UpdatedServiceType"
                                               name="UpdatedServiceType">
                                </CodeTypeValue>
                              </div>

                            </div>

                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>

              </div>
              <!--<div class="card-footer">
                <button type="submit" class="btn actions-btn-prime float-right font-size-13px">Save</button>
                <button type="button" class="btn btn-secondary btn-raised margin-right-15px float-right button-Schedule actions-btn-prime actions-btn-prime3 font-size-13px" (click)="activeModal.close('Close click')">Cancel</button>
              </div>-->
              <div class="card-footer padding-top-5px padding-bottom-5px padding-left-0px padding-right-0px">
                <div class="row margin-left-0px margin-right-0px" *ngIf="BranchWiseCosts">
                  <div class="table-component">
                    <div class="table-responsive overflow-x-hidden">
                      <table class="table table-striped margin-left-zero">
                        <thead class="">
                          <tr>
                            <th class="padding-top-0px padding-bottom-0px" *ngFor="let c of BranchWiseCosts">
                              {{c.ShortName}}
                            </th>
                          </tr>
                        </thead>
                        <tbody class="table-body">
                          <tr>
                            <td class="padding-top-0px padding-bottom-0px" *ngFor="let d of BranchWiseCosts">
                              {{d.BranchBasePrice}}
                            </td>
                          </tr>

                        </tbody>

                      </table>
                    </div>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <!--<div class="col-md-8">
                    <div class="row" *ngIf="BranchWiseCosts">
                      <div class="col-md-2" *ngFor="let c of BranchWiseCosts">
                        <div class="row">
                          <label>{{c.ShortName}}</label>
                        </div>
                        <div class="row">
                          <label>{{c.BranchBasePrice}}</label>
                        </div>
                      </div>
                    </div>
                  </div>-->
                  <div class="col-md-12">
                    <button type="submit" class="btn actions-btn-prime float-right font-size-13px">Save</button>
                    <button type="button" class="btn btn-secondary btn-raised margin-right-15px float-right button-Schedule actions-btn-prime actions-btn-prime3 font-size-13px"
                            (click)="activeModal.close('Close click')">
                      Cancel
                    </button>
                  </div>
                </div>

              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
